const levelUrls = {
    levels: {
        url: '/auth/levels'
    },
    level: {
        url: '/auth/levels/:id'
    }
};

export default levelUrls;